// extracted by mini-css-extract-plugin
module.exports = {"page-transition":"page-transition_page-transition__9d8zy"};